import React from 'react';
import { NavLink } from "../../../../../Common";
import { Text } from "../../../../../Typography";
import styles from './HeaderDesktopLink.scss';

var HeaderDesktopLink = function HeaderDesktopLink(_ref) {
  var children = _ref.children,
      to = _ref.to,
      onActiveNavLinkClick = _ref.onActiveNavLinkClick;
  return /*#__PURE__*/React.createElement(NavLink, {
    to: to,
    className: styles.headerLink,
    activeClassName: styles.headerLinkActive,
    onActiveNavLinkClick: onActiveNavLinkClick
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    color: "inherit"
  }, children));
};

export default HeaderDesktopLink;